




































import { Vue, Component, Prop } from 'vue-property-decorator';
import Wave from '../../directives/wave';
import { ButtonType } from '../base-button/types/enums/button-type';
import { BaseIcon } from '../base-icon';
import { BaseDropdown } from '../base-dropdown';

type SplitType = ButtonType.Primary | ButtonType.Secondary | ButtonType.Tertiary;

@Component({
  name: 'BaseButtonSplit',
  components: {
    BaseIcon,
    BaseDropdown,
  },
  directives: {
    Wave,
  },
})
export default class BaseButtonSplit extends Vue {
  @Prop() id: string;
  @Prop({ default: ButtonType.Primary }) buttonType: SplitType;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: '' }) dataExternal: string;

  get disabledButton() {
    return this.disabled;
  }

  get typeClass() {
    return `ga-${this.buttonType}`;
  }

  get buttonId() {
    return this.id || `button-${this['_uid']}`;
  }

  handlePrimaryClick(event: MouseEvent) {
    if (this.disabledButton) return;

    this.$emit('click', event);
  }
}
